import { Fabric8Tool } from '../../models/tool.model';
import { Fabric8ToolType } from '../Fabric8ToolType';

export const segmentTool: Fabric8Tool = {
  name: 'guide|segment',
  type: Fabric8ToolType.GUIDE_SEGMENT,
  radius: 1,
  enabled: true,
};
